import { graphql } from 'src/graphql';

// Identity (email / name / team) is derived server-side from the authenticated
// session, so this mutation takes no arguments. Returns true on success.
export const RequestDemo = graphql(`
  mutation RequestDemo {
    requestDemo
  }
`);
